<template>
  <div class="right">
    <div class="right_title">
      <div class="right_title_ch">报警信息</div>
      <div class="right_title_en">暂无报警信息</div>
    </div>
    <div class="rihgt_ftop">
      <dv-scroll-board :config="config" style="width:374px; float: right;" @click="warnMsgChange"/>
    </div>

    <div class="right_title">
      <div class="right_title_ch">
        <template v-if="index === 0">{{ option1.title.text1 }}</template>
        <template v-else-if="index === 1">{{ option2.title.text1 }}</template>
        <template v-else>{{ option3.title.text1 }}</template>
      </div>
      <div class="right_title_en">暂无报警信息</div>
    </div>
    <div class="right_realtime right_realtime-carousel">
      <div class="right-carousel">
        <div class="right_realtime_left">
          <div class="right_realtime_leftitem">
            <div>占用</div>
            <dv-digital-flop :config="vehicleOccupancy" style="width:60px;height:30px;"/>
            <!-- <span>1516</span> -->
          </div>
          <div class="right_realtime_leftitem">
            <div>未占用</div>
            <dv-digital-flop :config="vehicleOccupancyNo" style="width:60px;height:30px;"/>
            <!-- <span>361</span> -->
          </div>
        </div>
        <el-carousel @change="carouselChange" :interval="5000" indicator-position="none" arrow="never"
                     :autoplay="true">
          <el-carousel-item v-for="item in 3" :key="item">
            <div class="right_realtime_right">
              <dv-charts :option="option"/>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="right_title">
      <div class="right_title_ch">可燃气体检测</div>
      <div class="right_title_en">暂无报警信息</div>
    </div>
    <div class="right_realtime">
      <div class="right_realtime_right_bar">
        <dv-charts :option="option4"/>
      </div>
    </div>
    <div class="right_title">
      <div class="right_title_ch">重点区域监控</div>
      <!--      <div class="right_title_en">Monitoring of key areas</div>-->
      <div class="right_title_en">
        <el-select :popper-append-to-body="false" class="custom-select" size="mini" v-model="value"
                   placeholder="请选择">
          <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="right_fmonitor">
      <div class="right_fmonitor_left">
        <dv-digital-flop :config="monitorRealTime" style="width:118px;height:30px;"/>
        <p>监控数量</p>
      </div>
      <div class="right_fmonitor_right">
        <img src="../img/img.jpg" style="width: 270px; height: 155px"/>
      </div>
    </div>
  </div>
</template>

<script>
// right - 园区概览
import MapUtil from '../map/utils/mapUtil';
import CONSTANTS from "../map/constants";
import {mapGetters} from "vuex";

export default {
  name: "BottomTab",
  components: {},
  computed:{
    ...mapGetters([
      'warnList'
    ])
  },
  data() {
    return {
      // 重点区域监控
      options: [{
        value: '选项1',
        label: '水井房'
      }, {
        value: '选项2',
        label: '污染源'
      }, {
        value: '选项3',
        label: '大门'
      }],
      value: '',
      // 数量监控
      monitorRealTime: {
        number: [23],
        content: "{nt}",
        style: {
          fontSize: 22,
          fill: '#c97c0e',
          fontWeight: 'bold'
        }
      },
      // 报警信息
      config: {
        header: ["时间", "信息", "电量"],
        data: [],
        headerBGC: 'transparent', // 表头背景色
        oddRowBGC: 'transparent', // 奇数行背景色
        evenRowBGC: 'rgba(154,163,168,0.46)', // 偶数行背景色
        columnWidth: [160, 150, 50], // 列宽
        rowNum: 3,
        headerHeight: 26, // 行高
      },
      // 最低温度
      minTemperature: {
        number: [13],
        content: "{nt}℃",
        toFixed: 2,
        style: {
          fontSize: 17,
          fill: '#c97c0e',
          fontWeight: 'bold'
        }
      },
      // 最高温度
      maxTemperature: {
        number: [23],
        content: "{nt}℃",
        toFixed: 2,
        style: {
          fontSize: 17,
          fill: '#c97c0e',
          fontWeight: 'bold'
        }
      },
      // 最低湿度
      minHumidity: {
        number: [23],
        content: "{nt}℃",
        toFixed: 2,
        style: {
          fontSize: 17,
          fill: '#c97c0e',
          fontWeight: 'bold'
        }
      },
      // 最高湿度
      maxHumidity: {
        number: [23],
        content: "{nt}℃",
        toFixed: 2,
        style: {
          fontSize: 17,
          fill: '#c97c0e',
          fontWeight: 'bold'
        }
      },
      // 总人数
      personAll: {
        number: [23],
        content: "{nt}",
        style: {
          fontSize: 18,
          fill: '#fff',
          fontWeight: 'bold'
        }
      },
      // 员工
      personstaff: {
        number: [23],
        content: "{nt}",
        style: {
          fontSize: 12,
          fill: '#fff',
          fontWeight: 'bold'
        }
      },
      // 安保人数
      personSecurity: {
        number: [23],
        content: "{nt}",
        style: {
          fontSize: 12,
          fill: '#fff',
          fontWeight: 'bold'
        }
      },
      // 访客
      personVisitor: {
        number: [23],
        content: "{nt}",
        style: {
          fontSize: 12,
          fill: '#fff',
          fontWeight: 'bold'
        }
      },
      // 占用
      vehicleOccupancy: {
        number: [23],
        content: "{nt}",
        style: {
          fontSize: 18,
          fill: '#fff',
          fontWeight: 'bold'
        }
      },
      // 未占用
      vehicleOccupancyNo: {
        number: [24],
        content: "{nt}",
        style: {
          fontSize: 18,
          fill: '#fff',
          fontWeight: 'bold'
        }
      },
      option: {},
      // 折线 柱状 饼图
      option1: {
        title: {
          text1: '1号罐',
          style: {
            fontSize: 12,
            fill: '#FFFFFF'
          }
        },
        xAxis: {
          data: [
            "00:00",
            "04:00",
            "08:00",
            "12:00",
            "16:00",
            "20:00",
            "24:00",
          ],
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 10,
              rotate: 0,
            },
          },
          axisLine: {
            show: true, // 设置x轴线显示
            style: {
              stroke: "#fff",
              lineWidth: 1,
            },
          },
          axisTick: {
            show: false,
          },
          interval: 2,
        },
        yAxis: {
          name: "%",
          data: "value",
          nameTextStyle: {
            fill: "#fff",
            fontSize: 12,
          }, // 标题样式
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 10,
              rotate: 0,
            },
          },
          axisLine: {
            show: false, //设置y轴线
          },
          axisTick: {
            show: false, // 不显示刻度
          },
        },
        series: [{
          data: [200, 59, 80, 15, 60, 16, 76],
          type: "line",
          smooth: true,
          lineArea: {
            // 设置折线阴影
            show: true,
            gradient: ["rgba(201, 121, 14, 0.6)", "rgba(55, 162, 218, 0)"],
          },
        },],
        color: ["#c97c0e"], // 折线颜色
        grid: {
          style: {
            fill: "rgba(0, 0, 0, 0)",
          },
          top: "20px",
          left: "10px",
          right: "10px",
          bottom: "20px",
        },
        linePoint: {
          show: false,
        },
      },
      option2: {
        title: {
          text1: '2号罐',
          style: {
            fontSize: 12,
            fill: '#FFFFFF'
          }
        },
        xAxis: {
          data: [
            "00:00",
            "04:00",
            "08:00",
            "12:00",
            "16:00",
            "20:00",
            "24:00",
          ],
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 10,
              rotate: 0,
            },
          },
          axisLine: {
            show: true, // 设置x轴线显示
            style: {
              stroke: "#fff",
              lineWidth: 1,
            },
          },
          axisTick: {
            show: false,
          },
          interval: 2,
        },
        yAxis: {
          name: "%",
          data: "value",
          nameTextStyle: {
            fill: "#fff",
            fontSize: 12,
          }, // 标题样式
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 10,
              rotate: 0,
            },
          },
          axisLine: {
            show: false, //设置y轴线
          },
          axisTick: {
            show: false, // 不显示刻度
          },
        },
        series: [{
          data: [200, 59, 80, 15, 60, 16, 76],
          type: "line",
          smooth: true,
          lineArea: {
            // 设置折线阴影
            show: true,
            gradient: ["rgba(201, 121, 14, 0.6)", "rgba(55, 162, 218, 0)"],
          },
        },],
        color: ["#c97c0e"], // 折线颜色
        grid: {
          style: {
            fill: "rgba(0, 0, 0, 0)",
          },
          top: "20px",
          left: "10px",
          right: "10px",
          bottom: "20px",
        },
        linePoint: {
          show: false,
        },
      },
      option3: {
        title: {
          text1: '3号罐',
          style: {
            fontSize: 12,
            fill: '#FFFFFF'
          }
        },
        xAxis: {
          data: [
            "00:00",
            "04:00",
            "08:00",
            "12:00",
            "16:00",
            "20:00",
            "24:00",
          ],
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 10,
              rotate: 0,
            },
          },
          axisLine: {
            show: true, // 设置x轴线显示
            style: {
              stroke: "#fff",
              lineWidth: 1,
            },
          },
          axisTick: {
            show: false,
          },
          interval: 2,
        },
        yAxis: {
          name: "%",
          data: "value",
          nameTextStyle: {
            fill: "#fff",
            fontSize: 12,
          }, // 标题样式
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 10,
              rotate: 0,
            },
          },
          axisLine: {
            show: false, //设置y轴线
          },
          axisTick: {
            show: false, // 不显示刻度
          },
        },
        series: [{
          data: [20, 49, 30, 95, 30, 36, 26],
          type: "line",
          smooth: true,
          lineArea: {
            // 设置折线阴影
            show: true,
            gradient: ["rgba(201, 121, 14, 0.6)", "rgba(55, 162, 218, 0)"],
          },
        },],
        color: ["#c97c0e"], // 折线颜色
        grid: {
          style: {
            fill: "rgba(0, 0, 0, 0)",
          },
          top: "20px",
          left: "10px",
          right: "10px",
          bottom: "20px",
        },
        linePoint: {
          show: false,
        },
      },
      option4: {
        title: {
          text: '',
          style: {
            fontSize: 12,
            fill: '#FFFFFF'
          }
        },
        xAxis: {
          data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 10,
              rotate: 0,
            },
          },
        },
        yAxis: {
          name: '含量',
          data: 'value',
          nameTextStyle: {
            fill: "#fff",
            fontSize: 10,
          },
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 10,
              rotate: 0,
            },
          },
        },
        series: [
          {
            data: [120, 223, 100, 100, 500, 40, 85],
            type: 'bar',
            gradient: {
              color: ['#37a2da', '#67e0e3']
            }
          }
        ]
      },
      timer: null,
      time: 0,
      index: 0
    };
  },
  watch: {
    warnList:function (val) {
      //Todo 获取报警列表数据
      (this.warnList||[]).forEach((row)=>{
        this.config.data.push([row.createTime, row.warnMsg, row.electricity])
      })
      this.config = {
        ...this.config
      };
    }
  },
  mounted() {
    this.option = this.option1
    this.updateHandler();
  },
  methods: {
    /**
     * Todo:点击地图定位
     * @param row
     */
    warnMsgChange(row){
      let data  = this.warnList[row.rowIndex];
      let alarmLayer=MapUtil.getLayerByName(CONSTANTS.LAYER.ALARM);
      if(alarmLayer){
        //MapUtil.flyToByEntity(alarmLayer.getEntityById(data.timestamp),-90,0)
        MapUtil.flyTo(data.x,data.y,100,0,-90,0);
      }
    },
    carouselChange(index) {
      this.index = index
      this.option = this[`option${index + 1}`]


      if (index === 0) {
        this.vehicleOccupancy.number[0] = 23
        this.vehicleOccupancyNo.number[0] = 24
      } else if (index === 1) {
        this.vehicleOccupancy.number[0] = 1516
        this.vehicleOccupancyNo.number[0] = 361
      } else {
        this.vehicleOccupancy.number[0] = 516
        this.vehicleOccupancyNo.number[0] = 51
      }

      this.vehicleOccupancy = {
        ...this.vehicleOccupancy
      };
      this.vehicleOccupancyNo = {
        ...this.vehicleOccupancyNo
      };
    },
    /* start(){
      setInterval(this.updateHandler, 5000)
    }, */
    updateHandler() {
      /**
       * 只是这样做是无效
       * config指向的内存地址没有发生变化
       * 组件无法侦知数据变化
       */
      this.minTemperature.number[0] = 28;
      this.maxTemperature.number[0] = 35;
      this.minHumidity.number[0] = 34.3
      this.maxHumidity.number[0] = 37.3
      this.personAll.number[0] = 3233
      this.personstaff.number[0] = 928
      this.personSecurity.number[0] = 100
      this.personVisitor.number[0] = 323

      /**
       * 使用ES6拓展运算符生成新的props对象
       * 组件侦知数据变化 自动刷新状态
       */
      this.minTemperature = {
        ...this.minTemperature
      };
      this.maxTemperature = {
        ...this.maxTemperature
      };
      this.minHumidity = {
        ...this.minHumidity
      };
      this.maxHumidity = {
        ...this.maxHumidity
      };
      this.personAll = {
        ...this.personAll
      };
      this.personstaff = {
        ...this.personstaff
      };
      this.personSecurity = {
        ...this.personSecurity
      };
      this.personVisitor = {
        ...this.personVisitor
      };


      // this.vehicleOccupancy.number[0] = 516
      // this.vehicleOccupancyNo.number[0] = 61
      //
      // this.vehicleOccupancy = {
      //   ...this.vehicleOccupancy
      // };
      // this.vehicleOccupancyNo = {
      //   ...this.vehicleOccupancyNo
      // };


      this.monitorRealTime.number[0] = 56;
      this.monitorRealTime = {
        ...this.monitorRealTime
      };
    },
  },
};
</script>

<style lang="less">
.right_title {
  margin-top: -5px;
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  width: 400px;
  font-family: sans-serif;
  display: flex;
  margin: 20px auto 0;
  background: url(../img/bg_rightline.png) center bottom no-repeat;

  .right_title_ch {
    position: relative;
    font-size: 18px;
    letter-spacing: 2px;
    color: #fff;
    font-weight: bold;
    width: 160px;
    flex-shrink: 0;
  }

  .right_title_ch::before {
    position: absolute;
    content: "";
    right: 0;
    top: 10px;
    width: 2px;
    height: 13px;
    background: #b3c4c9;
  }

  .right_title_en {
    font-size: 11px;
    letter-spacing: 1px;
    color: #b3c4c9;
    padding-left: 10px;


    .custom-select {
      min-width: 120px;

      .el-input__inner {
        background-color: transparent;
        color: #FFFFFF;
      }

      .el-select, .el-input.is-focus, .el-input__inner {
        border-color: #c97c0e !important;
      }

      .el-select-dropdown {
        border: 1px solid #c97c0e !important;
        background: linear-gradient(to left, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 1)) !important;
      }

      .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
        background: rgba(201, 124, 14, 0.4) !important;
      }

      .el-popper[x-placement^=bottom] .popper__arrow::after {
        border-bottom-color: #c97c0e !important;
      }

      .el-select-dropdown__item.selected {
        color: #c97c0e !important;
      }
    }
  }
}

.right_temp {
  width: 400px;
  height: auto;
  overflow: hidden;
  margin: 10px auto 0;
  display: flex;

  .right_tempitem {
    position: relative;
    width: 50%;

    .right_tempword {
      font-size: 17px;
      color: #707678;
      padding-left: 2px;
      font-weight: bold;
      height: 32px;
      line-height: 32px;
      margin-top: 10px;
      padding-left: 10px;
      display: flex;

      span {
        color: #c97c0e;
        font-weight: bold;
        margin-left: 15px;
      }
    }

    .right_temptitle {
      text-align: center;
      height: 32px;
      line-height: 32px;
      color: #b3c4c9;
      font-size: 12px;
    }

    .right_tempimg {
      background: url(../img/img_wd.png) 20px center no-repeat;
    }

    .right_sdimg {
      background: url(../img/img_sd.png) 20px center no-repeat;
    }
  }

  .right_tempitem::before {
    width: 1px;
    height: 100px;
    background: #fff;
    position: absolute;
    left: 0;
    top: 12px;
    content: "";
  }
}

.right_person {
  display: flex;
  justify-content: center;
  font-family: sans-serif;
  margin-top: 25px;

  .right_person_all {
    width: 91px;
    height: 91px;
    background: url(../img/bg_memall.png) no-repeat;
    margin-right: 15px;

    div {
      font-size: 18px;
      color: #fff;
      text-align: center;
      margin-top: 38px;
      font-weight: bold;
    }

    p {
      font-size: 9px;
      color: #b3c4c9;
      letter-spacing: 2px;
      text-align: center;
      margin: 0;
    }
  }

  .right_person_sigle {
    width: 80px;
    margin: 0 3px;

    .dv-digital-flop {
      font-size: 12px;
      color: #fff;
      letter-spacing: 2px;
      background: url(../img/bg_memsigle.png) no-repeat;
      text-align: center;
      width: 58px;
      height: 58px;
      margin: 11px auto 0;
      overflow: hidden;
      line-height: 58px;
      font-weight: bold;
    }

    p {
      font-size: 12px;
      color: #b3c4c9;
      letter-spacing: 2px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      margin: 0;
      margin-top: 6px;
    }
  }
}

.right_realtime {
  height: 160px;
  overflow: hidden;
  display: flex;
  width: 400px;
  margin: 0px auto 0;

  .el-carousel {
    width: 100%;
  }

  .right-carousel {
    display: flex;
    width: 330px;
    margin: 0 auto;
  }

  .right_realtime_left {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: -28px;
    flex-shrink: 0;
    width: 100px;
    .right_realtime_leftitem {
      color: #b3c4c9;
      height: 30px;
      line-height: 30px;
      margin-top: 30px;
      margin-left: -14px;
      font-size: 12px;
      display: flex;
    }
  }

  .right_realtime_right {
    margin-left: -10px;
    height: 190px;
    width: 320px;

    .el-carousel__item {
      display: flex;
      align-items: center;
    }
  }

  .right_realtime_right_bar {
    margin-top: -27px;
    margin-left: 20px;
    height: 180px;
    width: 400px;
  }
}


.right_realtime-carousel {
  margin: 0px auto 0;
  width: 440px;

  .el-carousel__container {
    height: 200px;
  }
}

.right_average {
  height: 80px;
  background: url(../img/bg_average.png) center 20px no-repeat;
  width: 374px;
  margin: 20px auto 0;

  ul {
    display: flex;
    margin: 0;
    padding: 0;

    li {
      text-align: center;
      width: 124px;
      margin: 0;
      padding: 0;
      list-style-type: none;

      div {
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        color: #b3c4c9;
        letter-spacing: 0.5px;
      }

      p {
        margin: 0;
        padding: 0;
        height: 50px;
        line-height: 50px;
        font-size: 15px;
        color: #fff;
      }
    }

    .right_averageon {
      p {
        color: #c97c0e;
      }
    }
  }
}
</style>
